// extracted by mini-css-extract-plugin
export default {"smallTitle":"SmallTitle-module__smallTitle___aEy-i"};